<div class="flex flex-col w-full h-full">
  <div class="flex justify-start items-center lg:pt-2 sm:pt-0.5 heading">
    <div class="flex items-center">
      <div>
        <span class="text-base font-medium text-white">
          {{ "powercuts_and_backup_summary" | translate }}</span
        >
      </div>
      <img
        src="../../../../assets/images/info-icon.svg "
        class="ml-2 hidden"
        alt="Info"
      />
    </div>
  </div>

  <div
    class="flex flex-col flex-grow maincontent justify-center sm:items-center lg:ite mt-2"
  >
    <div
      class="grid grid-cols-2 text-white gap-x-2 sm:w-10/12 md:w-11/12 lg:w-full h-full py-2"
    >
      <!--1st-->
      <div
        class="p-1 col-span-1 flex lg:flex-row sm:flex-row justify-between items-center sp"
      >
        <div class="flexDirCol flex-grow">
          <div class="flex items-start">
            <span class="text-lg text-left">{{
              powercutDetailsandSummary?.backupDuration ?? "NA"
            }}</span>
          </div>
          <div class="mt-1 text-start">
            <span class="text-base text-dark-gray-content">{{
              "backup_duration" | translate
            }}</span>
          </div>
        </div>
        <div class="xxl:pr-6 sm:pr-[0.7rem]">
          <img
            src="../../../../assets/images/backup_duration.svg"
            alt=" Backup Duration"
          />
        </div>
      </div>
      <!--2nd-->
      <div class="p-1 col-span-1 flex flex-row justify-between items-center sp">
        <div class="flexDirCol flex-grow lg:ml-1.5 xxl:ml-2 sm:ml-1">
          <div class="flex items-start">
            <span class="text-lg text-left">{{
              powercutDetailsandSummary?.chargingDuration ?? "NA"
            }}</span>
          </div>
          <div class="mt-1 text-start">
            <span class="text-base text-dark-gray-content">
              {{ "charging_duration" | translate }}
            </span>
          </div>
        </div>
        <div>
          <img
            src="../../../../assets/images/charging_duration.svg"
            alt="Charging duration"
          />
        </div>
      </div>
      <!--3rd-->
      <div class="p-1 col-span-1 flex flex-row justify-between items-center sp">
        <div class="flexDirCol flex-grow">
          <div class="flex items-start">
            <span class="text-lg text-left">{{
              powercutDetailsandSummary?.totalPowerCuts ?? "NA"
            }}</span>
          </div>
          <div class="mt-1 text-start">
            <span class="text-base text-dark-gray-content">
              {{ "total_powercuts" | translate }}
            </span>
          </div>
        </div>
        <div class="xxl:pr-6 sm:pr-[0.5rem]">
          <img
            src="../../../../assets/images/total_powercuts_img.svg"
            alt="Total Power Cuts"
          />
        </div>
      </div>
      <!--4th-->
      <div class="p-1 col-span-1 flex flex-row justify-between items-center sp">
        <div class="flexDirCol flex-grow lg:ml-1.5 sm:ml-1 xxl:ml-2">
          <div class="flex items-start">
            <span class="text-lg text-left">{{
              powercutDetailsandSummary?.totalPowerCutDuration ?? "NA"
            }}</span>
          </div>
          <div class="mt-1 text-start">
            <span class="text-base text-dark-gray-content">
              {{ "powercut_duration" | translate }}
            </span>
          </div>
        </div>
        <div>
          <img
            src="../../../../assets/images/charging_duration.svg"
            alt="Charging Duration"
          />
        </div>
      </div>
    </div>
  </div>
</div>
